import { useFetchAllVehicleIncidents } from '@@partner:graphql/query/vehicleIncident/allVehicleIncidents.gql'
import { GQL_ID } from '@@partner:types:graphql'
import React from 'react'
import VehicleIncidentElement from './VehicleIncidentElement'
import { Button, Panel } from 'rsuite'
type VehicleShiftsListProps = {
  vehicleId: GQL_ID
}

export default function VehicleIncidentsList ({
  vehicleId
}: VehicleShiftsListProps) {

  const { vehicleIncidents, loading, error, hasMore, fetchNextPage} = useFetchAllVehicleIncidents({
    filter: {
      fields: [ 'vehicle_id' ],
      op: 'eq',
      value: vehicleId
    },
    pager: {
      limit: 10
    }
  })

  if (error) {
    return (
      <Panel bordered header="Ошибка загрузки" className="text-center">
        <p className="text-danger">Не удалось загрузить список инцидентов</p>
      </Panel>
    )
  }

  if (vehicleIncidents.length === 0) {
    return (
      <Panel bordered header="Нет инцидентов" className="text-center">
        <p className="text-muted">Не было происшествий</p>
      </Panel>
    )
  }

  return (
    <div className='VehicleIncidentsList'>
      { vehicleIncidents.map(vi => (
        <VehicleIncidentElement
          key={vi.id}
          vehicleIncident={vi}
          className='VehicleIncidentsList__Element my-5'
        />
      ))}
      { hasMore && (
        <div>
          <Button onClick={fetchNextPage} loading={loading} appearance='primary'>
            Загрузить еще
          </Button>
        </div>
      )}
    </div>
  )
}